import { render, staticRenderFns } from "./CreateReferral.vue?vue&type=template&id=1f2dc186&scoped=true"
import script from "./CreateReferral.vue?vue&type=script&lang=js"
export * from "./CreateReferral.vue?vue&type=script&lang=js"
import style0 from "./CreateReferral.vue?vue&type=style&index=0&id=1f2dc186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2dc186",
  null
  
)

export default component.exports